import type {Converter, ConverterArguments, XConverterKey} from '../types'
import {getLayout, getLeftColumnsWidth, getLeftMarginInPx, getParentWidth, getRightMarginInPx, getValue} from '../utils'
import type {CompRef, GridContainerLayout, GridItemLayout} from '@wix/document-services-types'
import {convertWidthToPx} from './width'

const justifySelfToPx = (converterArguments: ConverterArguments) => {
    const {measurementsMapAPI, compRef, value, pointers, extensionAPI} = converterArguments
    const {get} = measurementsMapAPI

    let x = 0

    const {justifySelf, margins} = value as GridItemLayout
    switch (justifySelf) {
        case 'center': {
            const parentWidth = getParentWidth(converterArguments)
            x = parentWidth / 2 - get.width(compRef) / 2
            x += getLeftMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            x -= getRightMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            break
        }
        case 'end': {
            const parentWidth = getParentWidth(converterArguments)
            x = parentWidth - get.width(compRef)
            x -= getRightMarginInPx(converterArguments, convertWidthToPx, margins)
            break
        }
        case 'start':
        case 'stretch':
        default:
            x = getLeftMarginInPx(converterArguments, convertWidthToPx, margins)
    }

    const parentRef = pointers.structure.getParent(compRef) as CompRef
    const parentLayout = getLayout(extensionAPI, parentRef)
    const containerLayout = parentLayout?.containerLayout as GridContainerLayout | undefined
    const columnGap = containerLayout?.columnGap
    let columnGapPx: number | undefined
    if (columnGap?.type) {
        columnGapPx = convertWidthToPx[columnGap.type]({
            ...converterArguments,
            value: getValue(columnGap)
        })
    }

    const leftColumnsWidth = getLeftColumnsWidth(converterArguments, columnGapPx)
    x += leftColumnsWidth

    return x
}

export const convertXToPx: Record<XConverterKey, Converter> = {
    justifySelf: justifySelfToPx
}
